/**
 * During the build of the project in one mode or another,
 * the code that will not correspond to the build mode will be cut out of the bundle
 *
 * example:
 * if development mode enabled, all code in production will be erased from bundle and vice versa
 */
export const isProductionMode = process.env.NODE_ENV === "production";

export const isDevelopMode = process.env.NODE_ENV === "development";

export const POSTHOG_API_KEY = import.meta.env.BUILD_POSTHOG_KEY || "";
